import { SentenceOffset } from '@chegg-wt/core-wa/state/types'
import { Feedback, FeedbackType } from '@chegg-wt/core-wa/types'
import { HistoryRemoveGrammarCards, HistoryRemoveParaphraseCards } from '../types'
import { getFeedbackKeyFromPosition, getKeyFromSentence } from './commonUtils'

export const addDiscardedFeedbacksForFiltering = (
  sentenceOffsets: SentenceOffset[],
  feedback: Feedback,
  removedGrammarCards: HistoryRemoveGrammarCards,
  removedParaphraseCards: HistoryRemoveParaphraseCards
) => {
  const sentence = sentenceOffsets.find((sentence) => sentence.id === feedback.sentenceId)
  const key = getKeyFromSentence(feedback.sentenceId, sentence.originalText)
  if (feedback.feedbackType === FeedbackType.GRAMMAR) {
    if (!removedGrammarCards.get(key)) {
      removedGrammarCards.set(key, new Set<string>())
    }
    const { position } = feedback
    removedGrammarCards.get(key).add(getFeedbackKeyFromPosition(position))
  } else removedParaphraseCards.set(key, true)
}
